import EditIcon from "@mui/icons-material/Edit";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useTranslation } from "react-i18next";
import { useShallow } from "zustand/react/shallow";

import { useButtonManager } from "~/managers/use-button-manager";
import { useCartStore } from "~/stores/use-cart-store";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import OrderActionContext from "./order-action-context";

export default function OrderActionContextDialog() {
  const { t } = useTranslation("common");

  const { openButtonDialog } = useButtonManager();

  const { orderContextOpen, setOrderContextOpen } = useCartStore(
    useShallow((state) => ({
      orderContextOpen: state.orderContextOpen,
      setOrderContextOpen: state.setOrderContextOpen,
    })),
  );

  return (
    <Dialog open={orderContextOpen} onOpenChange={setOrderContextOpen}>
      <DialogContent>
        <DialogHeader
          action={() => openButtonDialog()}
          actionIcon={<EditIcon />}
        >
          <DialogTitle>{t("Order.context_options")}</DialogTitle>

          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <ScrollArea className="max-h-[80vh] p-4">
          <OrderActionContext onClose={() => setOrderContextOpen(false)} />
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
